import { createIcon } from '@chakra-ui/react'

export const Play = createIcon({
  displayName: 'Play',
  viewBox: '0 0 11 14',
  d: 'M2.00006 3.64L7.27006 7L2.00006 10.36V3.64ZM6.10352e-05 0V14L11.0001 7L6.10352e-05 0Z',
})
